export default function PageWrapper(props) {
    return (
        <div className="limiter">
            <div className="container">
                {props.children}
            </div>
        </div>
    )
}